import { useQuery } from "react-query"
import PaymentAccountService from "../payment-account/service/paymentAccountService"
import SessionService from "../payment-account/service/sessionService"
import { isError } from "../state/helpers/Error"
import { PAYMENT_ACCOUNT_STATUS, sessionType } from "../utils"

//Get the current user session -> Create or get session by type
export const usePaymentAccountSession = (sessionType: sessionType) => {

    const { merchantID, isMerchantActive } = useGetPaymentAccounts()
    const { session, isLoading } = usePaymentAccountSessionByMerchantId(sessionType, merchantID)

    return {
        merchantID,
        isLoading,
        session,
        isMerchantActive
    }

}

export const usePaymentAccountSessionByMerchantId = (sessionType: sessionType, merchantID: string) => {
    const { data: session, isLoading } = useQuery(
        ["sessions", merchantID], async () => {
            const res = await SessionService.getSession(sessionType, merchantID)
            return res
        },
        {
            enabled: !!merchantID,
        }
    )

    return {
        isLoading,
        session,
    }
}

//Get the current payment account details
export const useGetPaymentAccounts = (locationID?: string) => {

    const { data: paymentAccounts, isLoading: isPaymentAccountsLoading, refetch } = useQuery(
        ["payment-accounts"], async () => {
            const res = await PaymentAccountService.getPaymentAccounts()

            if (isError(res)) {
                throw new Error()
            }

            return res
        }
    )

    const hasAccount = !!paymentAccounts && paymentAccounts.length > 0
    const defaultPaymentAccount = paymentAccounts && (paymentAccounts.find(pa =>
        (locationID && pa.getLocationIds().includes(locationID))) || paymentAccounts[0])
    const merchantID = defaultPaymentAccount && defaultPaymentAccount.getMerchantId() || ""
    const isMerchantActive = defaultPaymentAccount && defaultPaymentAccount.isActive()
    return {
        paymentAccounts,
        hasAccount,
        hasActiveAccount: hasAccount && paymentAccounts.some(paymentAccount => paymentAccount.getStatus() === PAYMENT_ACCOUNT_STATUS.ACTIVE),
        isLoading: isPaymentAccountsLoading,
        defaultPaymentAccount,
        merchantID,
        isMerchantActive,
        refetch
    }

}


// WEBPACK FOOTER //
// ./src/payment-processing/usePaymentAccountSession.tsx